<app-auth-navbar></app-auth-navbar>
<main class="rtl">
    <div class="relative py-16 flex content-center items-center justify-center min-h-screen-50">
        <div class="absolute top-0 w-full h-full bg-center bg-cover">
            <span class="bg-primary w-full h-full absolute" id="blackOverlay"></span>
        </div>
        <div class="container relative mx-auto">
            <div class="items-center flex flex-wrap">
                <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                    <div class="">
                        <h2 class="text-white font-semibold text-4xl leading-normal">
                            استاد ویزیت، ویزیت و مشاوره آنلاین پزشکی
                        </h2>
                        <app-search></app-search>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="py-16 main-bg">
        <div class="container mx-auto px-4">
            <div class="flex flex-wrap p-4">
                <div class="w-full bg-white rounded p-4 shadow">
                    <div class="flex flex-wrap ">
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                              <label class="block text-blueGray-600 text-sm font-bold mb-2"> مرتب سازی </label>
                              <select [(ngModel)]="tempSort" (change)="getDoctorsList(1)"
                                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" >
                                    <option value="null"> پیش فرض </option>
                                    <option value="popular"> محبوب ترین </option>
                                    <option value="experienced"> بیشترین تجربه </option>
                              </select>      
                            </div>
                        </div>
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                              <label class="block text-blueGray-600 text-sm font-bold mb-2"> تخصص </label>
                              <select [(ngModel)]="expertiesId" (change)="getDoctorsList(1);getSubCategoriesList(expertiesId)"
                                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" >
                                    <option value="null"> همه </option>
                                    <option *ngFor="let cat of categoriesList" [value]="cat.id"> {{cat.name}} </option>
                              </select>
                            </div>
                        </div>
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                              <label class="block text-blueGray-600 text-sm font-bold mb-2"> زیر مجموعه </label>
                              <select [(ngModel)]="expertiesId" (change)="getDoctorsList(1)"
                                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" >
                                    <option value="null">---</option>
                                    <option *ngFor="let sub of subCategoriesList" [value]="sub.id"> {{sub.name}} </option>
                              </select>      
                            </div>
                        </div>
                        <div class="w-full lg:w-3/12 px-4">
                            <div class="relative w-full mb-3">
                              <label class="block text-blueGray-600 text-sm font-bold mb-2"> نسخه نویسی آنلاین </label>
                              <select [(ngModel)]="attendanceVisit" (change)="getDoctorsList(1)"
                                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" >
                                    <option value="null"> همه </option>
                                    <option value="true"> دارد </option>
                                    <option value="false"> ندارد </option>
                              </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap">

                <div *ngFor="let doctor of searchResults" class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <div class="relative flex break-words min-h-120-px">
                            <img alt="..." onerror="this.onerror=null; this.src='../../../assets/img/thumb-profile1.svg.png';"
                            [src]="doctor.profilePic?apiService.api+doctor.profilePic:'../../../assets/img/thumb-profile1.svg.png'" 
                            class="shadow-lg rounded-full w-20 h-20 object-cover aspect-square mt-3" />
                            <div class="p-3">
                                <h5 class="text-lg font-bold"> دکتر {{doctor.name}} {{doctor.family}} </h5>
                                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                    {{doctor.medicalEspertiseName}}
                                </p>
                                <div class="flex items-center mt-1">
                                    <svg class="w-5 h-5 mx-1 text-yellow-300 me-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                                    </svg>
                                    <p class="me-2 text-sm font-bold text-gray-800 "> {{doctor?.averageRate}} </p>
                                    <!-- <span class="text-sm font-medium text-gray-800 mx-2"> 
                                        ({{doctor?.comments.length!=0?doctor?.comments.length:null}} نظر)</span> -->
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="mt-4">
                            <p class="text-base"> خدمات: </p>
                        </div>
                        <div class="flex flex-wrap ">
                            <p class="text-sm flex p-2"> <img src="../../../../assets/img/icon/video-call.svg" alt=""  width="20px"> <span> ویزیت تصویری </span></p>
                            <p class="text-sm flex p-2"> <img src="../../../../assets/img/icon/voice-call.svg" alt="" width="16px"> ویزیت صوتی </p>
                            <p class="text-sm flex p-2"> <img src="../../../../assets/img/icon/message.svg" alt="" width="20px"> مشاوره متنی </p>
                            <p class="text-sm flex p-2"> <img src="../../../../assets/img/icon/hospital.svg" alt="" width="16px"> ویزیت حضوری </p>
                        </div>
                        <div class="mt-2 flex justify-end">
                            <button class="bg-primary text-white w-1/2 h-8 rounded outline-none focus:outline-none mb-1"
                                type="button" [routerLink]="['/doctor-detail/'+doctor.id]"> دریافت نوبت
                            </button>
                        </div>
                    </div>
                </div>

            </div>

            <!-- <div class="flex justify-center">
                <p-paginator dir="rtl" (onPageChange)="getDoctorsList($event.page+1)" [first]="first" [rows]="rows"
                  [totalRecords]="collectionSize" [showCurrentPageReport]="true" [showPageLinks]="true"
                  [showJumpToPageDropdown]="false"  />

            </div> -->
            <div class="flex justify-center">

                  <p-paginator #paginator dir="rtl" (onPageChange)="getDoctorsList($event.page+1)" [first]="first" [rows]="rows" 
                    [totalRecords]="collectionSize" [rowsPerPageOptions]="false" />

            </div>
        </div>
    </section>


</main>
<app-footer></app-footer>